import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/common.css'
import './assets/js/jquery-1.9.1.min.js'
import './assets/js/jquery.min.js'
import './assets/js/common.js'
import './assets/font/icon.css'
import '../static/font/style.css'
import './assets/css/iconfont.css'
// 引入videojs
import Video from 'video.js';
import 'video.js/dist/video-js.css';
Vue.prototype.$video = Video; 
import hls from 'videojs-contrib-hls';
Vue.use(hls); // 要播放hls流
//引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import iView from 'iview';
import echarts from 'echarts'
import Axios from 'axios'
Vue.prototype.$axios = Axios;
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(iView);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js